import { ProductTileModel } from "@api/mappers/products.mapper";

export const ProductLine = {
    Onduvilla: "Onduvilla",
    OnduLineEasyfix: "OnduLineEasyfix",
    OndulineOndalux: "OndulineOndalux",
    OndulineEasyline: "OndulineEasyline",
} as const;
export type ProductLineType = (typeof ProductLine)[keyof typeof ProductLine];

export enum OndulineColor {
    Black = "0",
    Red = "1",
    Green = "2",
    Brown = "3",
}

export type SlopeConfig = {
    below?: number;
    above?: number;
    division: number;
    fixtures: number;
    warning?: boolean;
};

export type OndulineProduct = {
    color: OndulineColor;
    sku: string;
};

export type FormulaResult = number;

export type OndulineProductAccessory = Omit<OndulineProduct, "color"> & {
    amountFormula: (length: number, width: number) => FormulaResult;
    requiredFixtures: number;
    twoSideMultiplier: number;
    condition?: (activeAcc: Array<OndulineProductTileModel>) => boolean;
    color?: OndulineColor;
};

export type OndulineProductTileModel = ProductTileModel & {
    amount: number;
    requiredFixtures: number;
    twoSideMultiplier: number;
};

export type CorrugatedSheetShoppingList = {
  surface: number;
  slope: number;
  productLine?: ProductLineType;
  hasSlopeWarning: boolean;
  fixture?: OndulineProductTileModel;
  sheet?: OndulineProductTileModel;
  accessories?: Array<OndulineProductTileModel>;
  color?: OndulineColor;
};